import { TradeCyclesService_tradeCyclesServiceGetEntities } from '@festina/unitlink-general-types/unitlink/hooks/TradeCyclesService_tradeCyclesServiceGetEntities'

export const useFetchTradeCycles =
  TradeCyclesService_tradeCyclesServiceGetEntities.useSuspenseQuery
